import React, { useState } from "react";

const NAVLINKS = ["Home", "Features", "Pricing", "FAQ"];

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const LI = (props) => {
    return (
      <li className="text-white list-none z-10 hover:text-neon">
        <a href="@">{props.text}</a>
      </li>
    );
  };

  const openMenu = () => {
    if (isMenuOpen === true) {
      setIsMenuOpen(false);
      document.body.style.overflow = "scroll";
    } else {
      setIsMenuOpen(true);
      document.body.style.overflow = "hidden";
    }
  };

  const onClickingMenuItems = (event) => {
    event.preventDefault();
    setIsMenuOpen(false);
    setTimeout(() => {
      window.location = event.href;
    }, 1000);
  };

  return (
    <div>
      <div
        className="absolute w-full flex flex-col items-center justify-center h-screen z-30 bg-black p-8 top-0 transition-all duration-1000"
        style={{ transform: isMenuOpen ? "translateX(0%)" : "translateX(100%)" }}>
        <div className="flex flex-col gap-y-12 items-center">
          {NAVLINKS.map((navlink) => {
            return (
              <li key={Math.random()} className="list-none">
                <a href="@" className="text-neon text-2xl" onClick={onClickingMenuItems}>
                  {navlink}
                </a>
              </li>
            );
          })}
        </div>
      </div>
      <header className="flex justify-between items-center p-8 sm:p-16 tracking-widest">
        <a href="." className="text-neon md:text-xl z-40">
          Quickdraw
        </a>
        <button className="md:hidden z-40" onClick={openMenu}>
          <div className="text-neon font-bold">-</div>
          <div className="text-neon font-bold -mt-4">-</div>
        </button>
        <nav className="gap-x-16 hidden md:flex">
          {NAVLINKS.map((navlink) => {
            return <LI key={Math.random()} text={navlink}></LI>;
          })}
        </nav>
      </header>
    </div>
  );
};

export default Navigation;
